export const LOGIN_USER = "LOGIN_USER";
export const REGISTER_USER = "REGISTER_USER";
export const USER_DETAIL = "USER_DETAIL";
export const CLUB_LIST = "CLUB_LIST";
export const CLUB_LIST_UPDATE = "CLUB_LIST_UPDATE";
export const MAKE_HOME_CLUB = "MAKE_HOME_CLUB";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
